import * as React from "react";
import { PanelStack, Classes, IPanel } from "@blueprintjs/core";
import { useTl } from "../../../../../hooks";
import styled from "styled-components";
import { ClubContactSelectorPanel } from "./ClubContactSelectorPanel";
import { ClubContactFormPanel, IClubContactFormPanelProps } from "./ClubContactFormPanel";
import { PersonGridDto } from "../../../../../api";
import { ETLCodes } from "../../../../../locales";

export interface IClubContactSelectorProps extends Pick<IClubContactFormPanelProps, "onSaved"> {
  clubId: number;
}

const Container = styled.div`
  flex: 1;
  height: 100%;
  & > .${Classes.PANEL_STACK} {
    height: 100%;
  }
`;

export const ClubContactPanelStack: React.FunctionComponent<IClubContactSelectorProps> = ({ clubId, onSaved }) => {
  const { t } = useTl();

  const onContactSelected = React.useCallback(
    (data: PersonGridDto) => {
      setPanelStack((currentStack) => [
        ...currentStack,
        { component: () => <ClubContactFormPanel onSaved={onSaved} person={data} /> },
      ]);
    },
    [onSaved]
  );

  const [panelStack, setPanelStack] = React.useState<IPanel[]>([
    {
      component: () => <ClubContactSelectorPanel onContactSelected={onContactSelected} />,
      title: t(ETLCodes.SelectContact),
    },
  ]);

  const removeFromPanelStack = React.useCallback(() => {
    setPanelStack((prev) => prev.slice(0, prev.length - 1));
  }, [setPanelStack]);

  return (
    <Container className={Classes.DIALOG_BODY}>
      <PanelStack stack={panelStack} showPanelHeader={false} onClose={removeFromPanelStack} />
    </Container>
  );
};
